import { IMusicProductPhysicalAlbum } from "services/music-product-physical/types/form";
import { IMusicProductPhysicalTrackMutation } from "services/music-product-physical/types/mutation";

export const convertAlbumsModelToTracks = (
  albums: IMusicProductPhysicalAlbum[]
): IMusicProductPhysicalTrackMutation[] =>
  albums
    .map((album) =>
      album.tracks.map((track, index) => ({
        trackId: track.id,
        albumNumber: album.albumNumber,
        albumPlacement: index + 1,
      }))
    )
    .flat();
